module.exports = require("@gauzy/plugin-jitsu-analytics");